import { connect } from 'react-redux';
import { ThunkDispatch } from "redux-thunk";

import BasicDataPanel from '../components/BasicDataPanelView';

import { setAudience, setGoals, setMainMessage, Action } from '../actions';
import { getBasicData, State } from '../reducers';


interface StateProps {
    readonly goals: string,
    readonly mainMessage: string,
    readonly audience: string,
}

interface DispatchProps {
    readonly onGoalsChanged: (goals: string) => void,
    readonly onMainMessageChanged: (mainMessage: string) => void,
    readonly onAudienceChanged: (audience: string) => void,
}


const mapStateToProps = (state: State): StateProps => {
    const {goals, mainMessage, audience} = getBasicData(state);
    return {
        goals,
        mainMessage,
        audience
    };
}

const mapDispatchToProps = (dispatch: ThunkDispatch<State, any, Action>): DispatchProps => (
    {
        onGoalsChanged: (goals: string): void => {
            dispatch(setGoals(goals));
        },
        onMainMessageChanged: (mainMessage: string): void => {
            dispatch(setMainMessage(mainMessage));
        },
        onAudienceChanged: (audience: string): void => {
            dispatch(setAudience(audience));
        }
    }
);


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(BasicDataPanel);



// WEBPACK FOOTER //
// ./src/containers/BasicDataPanel.ts